export { default as EN } from "./en.json";
export const API_KEYS_NAMESPACE = "api-keys";
